<template>
  <div>
    <notifications :group="groupNotify"
                   :closeOnClick="false"
                   :width="500"
                   :max="5"
                   animation-name="v-fade-left"
                   position="top left">
      <template v-slot:body="props">
        <div class="custom-template">
          <div class="custom-template-icon">
            <a target="_blank" :href="props.item.data.url" class="link">
              <img :src="props.item.data.images && props.item.data.images.small.length ? props.item.data.images.small[0] : '/upload/empty/58.png'" width="58">
            </a>
          </div>
          <div class="custom-template-content">
            <div class="custom-template-title">
              {{ props.item.title }}
            </div>
            <div class="custom-template-text"
                 v-html="props.item.text"></div>
          </div>
          <div class="custom-template-close"
               @click="close(props.item.data.id)">
            <i class="icon icon-close"></i>
          </div>
        </div>
      </template>
    </notifications>
    <modal-sertificate
        v-if="isModalSertificateVisible"
        @close="closeModalSertificate"
        :item="item"
    />
    <div class="catalog" v-show="item && Object.keys(item).length > 0">
      <h1>
        {{ item.name }}
      </h1>
      <breadcrumbs :items="item.breadcrumbs" :name="item.name"></breadcrumbs>
      <div class="catalog catalog_view_detail">
        <div class="catalog__product-info product product_view_card">
          <div class="product__content-inner">

            <div class="product__header-info">
              <div class="product__options-info">
                      <span class="product__options-info-item">Код:
                        <vue-popper :id="item.id + '-xmlid'"
                                    :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{
                            item.code
                          }}</vue-popper>
                      </span>
                <span class="product__options-info-item">Артикул:
                        <vue-popper :id="item.id + '-vendorCode'"
                                    :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{
                            item.vendorCode
                          }}</vue-popper>
                      </span>
                <span class="product__options-info-item">Штрих-код:
                        <vue-popper :id="item.id + '-barcode'"
                                    :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{
                            item.barcode
                          }}</vue-popper>
                      </span>
              </div>

              <product-statuses :item="item" v-if="user.isAuthorized"></product-statuses>
            </div>

            <div class="product__picture">
              <div class="product__badges" v-if="item.badge && item.badge.length > 0">
                <span class="product__badge" v-if="item.badge.includes('hit')">Хит</span>
                <span class="product__badge" v-if="item.badge.includes('new')">Новинка</span>
                <span class="product__badge" v-if="item.badge.includes('action')">Акция</span>
              </div>
              <div class="product__picture-slider">
                <template v-if="item.images && item.images.large.length > 0">
                  <vue-swiper :images="item.images.large" :key="item.id" :item-id="item.id"></vue-swiper>
                </template>
                <template v-else>
                  <div class="thumb-image img-content">
                    <img src="/img/empty-600.png">
                  </div>
                </template>
              </div>
              <div class="product__to_favorite" @click="toFavorite(item)">
                      <span class="icon"
                            :class="{'icon-heart': !item.favorite, 'icon-heart-full': item.favorite}"></span>
              </div>
            </div>

            <div class="product__actions" v-if="!item.is_archive">
              <div class="product__prices" v-if="user.isAuthorized">
                <div class="product__price product__price_type_old" v-if="item.price.stock != item.price.price">
                  {{ Math.round(item.price.stock * item.step * 100) / 100  }} Р.
                  <span class="percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent ">
                      <span class="percent-badge__value">
                        <vue-popper :id="item.id + '-el-percent'"
                                    :hint="'Ваша персональная скидка на данную категорию товаров'">{{
                            item.price.percent
                          }}</vue-popper>
                      </span>
                  </span>
                </div>

                <div class="product__price">
                  {{ Math.round(item.price.price * item.step * 100) / 100  }} Р.
                </div>
                <div v-if="item.dimensions" class="product__buy-action">
                  <product-summary-controls :item="item" :productId="item.id" :v="item.dimensions.volume" :x="item.code"></product-summary-controls>
                </div>
              </div>

            </div>
            <div class="product__noreg-box" v-else>
              <div class="product__noreg-box-text">
                Видеть цены и покупать могут только зарегистрированные пользователи
              </div>

              <a :href="'/auth/?login=yes&backurl=' + back_url"
                 class="product__noreg-box-button button button_theme_primary_blue button_size_md">
                <span class="button__text">Войти и купить</span>
              </a>

              <a :href="'/auth/?register=yes&backurl=' + back_url">Зарегистрироваться</a>
            </div>
          </div>

        </div>
      </div>

      <div class="product__main-info">
        <div class="product__options-group">

          <ul v-if="item.dimensions" class="product__options product__options_lists">
            <li class="product__options-item"
                v-if="item.dimensions.volume">
              <span class="product__options-item-caption">Объем</span>
              <span class="product__options-item-value">{{ item.dimensions.volume }} м³</span>
            </li>
            <li class="product__options-item"
                v-if="item.dimensions.size">
              <span class="product__options-item-caption">Размер(ГхШхВ)</span>
              <span class="product__options-item-value">{{ item.dimensions.size }} см</span>
            </li>
            <li class="product__options-item"
                v-if="item.dimensions.weight != ''">
              <span class="product__options-item-caption">Вес (грамм)</span>
              <span class="product__options-item-value">{{ item.dimensions.weight }}</span>
            </li>
            <li class="product__options-item"
                v-if="item.dimensions.pack_size">
              <span class="product__options-item-caption">Размер упак.(ГхШхВ)</span>
              <span class="product__options-item-value">{{ item.dimensions.pack_size }} см</span>
            </li>

            <li class="product__options-item" v-for="(value, name, index) in item.properties">
              <span class="product__options-item-caption">{{ name }}</span>
              <span class="product__options-item-value">
                  <template v-if="typeof value == 'object'">
                    <a :href="value.url">{{ value.text }}</a>
                  </template>
                  <template v-else>
                    {{ value }}
                  </template>
                </span>
            </li>
          </ul>

          <a href="javascript:void(0);" class="action-link action-link_default js-view-all-haracteristik"
             v-if="isProps">
            <span class="action-link__text">Все характеристики</span>
          </a>


        </div>

      </div>

      <div class="catalog__description">

        <template v-if="item.description && (item.description.preview || item.description.detail)">
          <h3 class="catalog__description-title">Описание</h3>
          <p v-if="item.description.preview" v-html="item.description.preview"></p>
          <p v-if="item.description.detail" v-html="item.description.detail"></p>
        </template>

        <div v-if="item.certificates && item.certificates.length > 0"
             class="product__action-link product__action-link_sertificat popup-image-gallery"
             style="float: left; margin-right: 20px;">
          <a :href="'/upload/cert/' + item.certificates[0]" @click.prevent="showModalSertificate()"
             class="product__action-link-text">
            <span class="product__action-link-icon icon icon-sertificat"></span>
            Сертификат
          </a>
        </div>
        <div class="product__action-link product__action-link_sertificat popup-image-gallery"
             v-if="item.youtube_id" style="position: unset;">
          <a target="_blank" :href="'https://www.youtube.com/watch?v=' + item.youtube_id"
             class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Видео">
            Видео <img src="/img/youtube.png" style="height: 25px;">
          </a>
        </div>
        <div class="product__action-link product__action-link_sertificat popup-image-gallery"
             v-if="item.manual" style="position: unset;">
          <a target="_blank" :href="'/upload/manuals/' + item.vendorCode + '.pdf'"
             class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Инструкция">
            Инструкция по сборке <img src="/img/pdf.png" style="height: 25px;">
          </a>
        </div>

      </div>
    </div>

    <vue-swiper-products v-show="item && Object.keys(item).length > 0" :user="user" :items="item.analogues" :key="item.id" :item-id="item.id"></vue-swiper-products>

  </div>
</template>

<script>
import ModalElement from "./ModalElement.vue";
import Breadcrumbs from "./Breadcrumbs.vue";
import VueSwiper from "./VueSwiper.vue";
import VueSwiperProducts from "./VueSwiperProducts.vue";
import VuePopper from "./VuePopper.vue";
import ModalSertificate from "./ModalSertificate.vue";
import ProductStatuses from "./ProductStatuses.vue";
import axios from "axios";
import ProductSummaryControls from './ProductSummaryControls.vue';

export default {
  data: function () {
    return {
      maxProps: 6,
      isModalSertificateVisible: false,
      back_url: window.btoa(this.$route.path),
      basket: this.$ls.get('basket'),
      notifyIds: [],
      groupNotify: 'custom-template'
    }
  },
  mounted() {

  },
  computed: {
    cart() {
      let result = 0;
      let vm = this;

      if ('items' in this.$store.getters.page && this.$store.getters.page.items.length > 0) {
        if (this.basket && 'items' in this.basket && this.basket.items.length > 0) {
          this.basket.items.forEach(function (basketItem) {
            if (vm.$store.getters.page.items[0].id == basketItem.productId)
              result = basketItem.quantity;
          });
        }
      }

      return result;
    },
    item() {
      let result;
      if ('items' in this.$store.getters.page && this.$store.getters.page.items.length > 0)
        result = this.$store.getters.page.items[0];
      else
        result = {};
      return result;
    },
    isProps() {
      let result;
      if ('items' in this.$store.getters.page && this.$store.getters.page.items.length > 0)
        result = Object.keys(this.$store.getters.page.items[0].properties).length > this.maxProps;
      else
        result = false;
      return result;
    },
    user() {
      let result;
      if ('user' in this.$store.getters.page)
        result = this.$store.getters.page.user;
      else
        result = {};
      return result;
    },
  },
  methods: {
    drawNotify: function (item, result) {
      let id = item.id;
      if (this.user.isAuthorized) {
        if (this.notifyIds.length > 0) {
          this.notifyIds.forEach(notifyId => {
            if (notifyId == id)
              this.$notify.close(id);
          })
        }

        let message = result.message;
        if (result.type == 'change')
          message = message + ' на ' + result.result.quantity + '. ';

        if (result.type == 'add')
          message = message + ' в количестве ' + result.result.quantity + '. ';

        this.$notify({
          id,
          group: this.groupNotify,
          title: message + 'Вы будете уведомлены по поступлению товара на склад.',
          text: item.name,
          type: '',
          duration: 4000,
          speed: 0,
          data: item
        });
        this.notifyIds.push(id);
      }
    },
    close: function (id) {
      this.$notify.close(id);
    },
    toFavorite: function (item) {
      if (item.favorite > 0) {
        axios.post(
            '/api/favorite/delete',
            {
              'id': item.favorite
            },
            {
              headers: {
                'content-type': 'application/json; charset=utf8',
                'X-Requested-With': 'XMLHttpRequest',
              },
            }
        )
            .then(function (response) {
              if (response.data.status)
                item.favorite = response.data.result;
            })
            .catch(function (error) {
              console.log(error);
            });
      } else {
        axios.post(
            '/api/favorite/add',
            {
              'code': item.code
            },
            {
              headers: {
                'content-type': 'application/json; charset=utf8',
                'X-Requested-With': 'XMLHttpRequest',
              },
            }
        )
            .then(function (response) {
              if (response.data.status)
                item.favorite = response.data.result;
            })
            .catch(function (error) {
              console.log(error);
            });
      }
    },

    showModalSertificate() {
      this.isModalSertificateVisible = true;
    },
    closeModalSertificate() {
      this.isModalSertificateVisible = false;
    },

    selectText: function (element) {
      let range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    copy: function (event) {
      if (navigator.clipboard != undefined) {
        let value = event.target.innerHTML;
        navigator.clipboard.writeText(value)
      } else {
        this.selectText(event.target);
        document.execCommand("copy");
      }
    },
  },
  components: {
    VueSwiper,
    VueSwiperProducts,
    VuePopper,
    ModalElement,
    ModalSertificate,
    Breadcrumbs,
    ProductStatuses,
    ProductSummaryControls
  }

}
</script>

<style>

</style>